import { merge, $ } from "glamor";
import memoizeOne from "memoize-one";
import { theme } from "styles/theme";

const CARD_WIDTH = 164;
const ADDITIONAL_INFO_HEIGHT = 106;
const IMAGE_HEIGHT = 228;
const IMAGE_WIDTH = 148;

const getStyles = memoizeOne(() => {
    return merge(
        $(" .node", {
            padding: "8px",
            background: theme.palette.canvasColor,
            width: `${CARD_WIDTH}px`,
            height: "auto",
            cursor: "pointer",
            transition: "all 0.2s ease-out",
            borderRadius: "5px 5px 0 0",
            position: "relative",
            overflow: "hidden",
            boxShadow: "0 1px 0 0 #cdcdcd",
        }),
        $(" .node:hover", {
            borderRadius: "5px",
            boxShadow: "0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.2), 0 1px 5px 0 rgba(0,0,0,.12)",
        }),
        $(" .node:hover .hasDoors", {
            opacity: 0,
        }),
        $(" .node:hover .node-unitaryDetails", {
            display: "block",
        }),
        $(" .node-unitaryDetails", {
            backgroundColor: "#585858",
            boxSizing: "border-box",
            color: "#fff",
            display: "none",
            bottom: 0,
            left: 0,
            padding: "1rem 0.5rem",
            position: "absolute",
            right: 0,
            zIndex: 2,
        }),
        $(" .node-unitaryDetails p", {
            margin: "0 0 0.5rem 0",
        }),
        $(" .node-unitaryDetails dt", {
            display: "inline-block",
        }),
        $(" .node-unitaryDetails dd", {
            display: "inline-block",
        }),
        $(" .node-unitaryDetails p:last-child", {
            marginBottom: 0,
        }),
        $(" .node-unitaryDetails strong", {
            fontWeight: "bold",
        }),
        $(" .dragHandle", {
            position: "absolute",
            opacity: 0,
            transition: "all 0.2s ease-out",
            touchAction: "none",
            zIndex: 11,
            backgroundColor: "#fff",
            borderRadius: "50%",
            width: "24px",
            height: "24px",
        }),
        $(" .isTouchDevice & .node .dragHandle", {
            opacity: 1,
            top: 0,
            left: "50%",
            transform: "translateX(-50%)",
        }),
        $(" .node:hover .dragHandle", {
            opacity: 1,
        }),
        $(" .images", {
            margin: "0",
            height: `${IMAGE_HEIGHT}px`,
            position: "relative",
            width: "100%",
            overflow: "hidden",
        }),
        $(" .image", {
            height: `${IMAGE_HEIGHT}px`,
            //    width: "100%",
        }),
        $(" .primaryImage", {
            width: `${IMAGE_WIDTH}px`,
            height: `${IMAGE_HEIGHT}px`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
            transition: "all 0.2s ease-out",
        }),
        $(" .secondaryImageUrl", {
            position: "absolute",
            top: 0,
            left: 0,
            opacity: 0,
            width: `${IMAGE_WIDTH}px`,
            height: `${IMAGE_HEIGHT}px`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
            transition: "all 0.2s ease-out",
        }),
        $(" images:hover .secondaryImageUrl", {
            opacity: 1,
        }),
        $(" .imageIcons", {
            alignItems: "center",
            background: "rgba(0,0,0,.5)",
            bottom: "70px",
            color: "white",
            display: "flex",
            fontSize: "14px",
            height: "40px",
            paddingLeft: "8px",
            position: "absolute",
            textAlign: "center",
            width: "100%",
            right: "0px",
        }),
        $(" .brokenImageWrapper", {
            position: "absolute",
            bottom: "10px",
            left: "4px",
        }),
        $(" .imageIcons svg", {
            height: "30px !important",
            padding: "1px",
            width: "30px !important",
        }),
        $(" .noImage", {
            height: `${IMAGE_HEIGHT}px`,
            background: theme.palette.lighterGrey,
        }),
        $(" .additionalInfo", {
            // minHeight: `${ADDITIONAL_INFO_HEIGHT}px`,
            maxHeight: `${ADDITIONAL_INFO_HEIGHT}px`,
        }),
        $(" .additionalInfo > div", {
            fontSize: "10px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            lineHeight: "14px",
            paddingTop: "2px",
        }),
        $(" .additionalInfo .image", {
            height: "20px",
            width: "20px",
        }),
        $(" .additionalInfo .svg", {
            height: "20px",
            width: "20px",
        }),
        $(" .title", {
            height: "20px",
            lineHeight: "20px",
            fontSize: "14px",
            letterSpacing: "0.2px",
            fontWeight: "bold",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            color: theme.palette.darkerGrey,
        }),
        $(" .subtitle, .text, .subtext", {
            height: "20px",
            lineHeight: "20px",
            fontSize: "12px",
            letterSpacing: "0.1px",
            color: theme.palette.darkerGrey,
        }),
        $(" .subtitle", {
            color: theme.palette.darkGrey,
            display: "flex",
        }),
        $(" .subtitle > div", {
            position: "absolute",
            paddingLeft: "22px",
            overflow: "hidden",
            height: "20px",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        }),
        $(" .groupHeader", {
            backgroundColor: theme.palette.lightestGrey,
            borderRadius: "5px",
            margin: "0 4px",
            height: "72px",
            overflow: "auto",
        }),
        $(" .groupHeader h3", {
            margin: "0",
            padding: "0 16px",
            fontSize: "28px",
            lineHeight: "72px",
        }),
        $(" .groupTitle", {
            paddingLeft: "20px",
            height: "36px",
            lineHeight: "36px",
            fontSize: "17px",
        }),
        $(" .groupStats", {
            display: "flex",
        }),
        $(" .groupStat", {
            padding: "0 20px",
        }),
        $(" .groupStatTitle", {
            fontWeight: "bold",
        }),
        $(" .primaryAttribute", {
            fontSize: "12px",
            fontWeight: "bold",
            color: "#2d2d2d",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            lineHeight: "16px",
            paddingTop: "4px",
        }),
        $(" .colorCarousel", {
            height: "30px",
            display: "flex",
            justifyContent: "center",
            margin: "4px 0",
        }),
        $(" .brandAttribute", {
            width: "100%",
            height: "16px",
            fontFamily: "Lato",
            fontSize: "10px",
            color: "#989898",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            lineHeight: "16px",
            paddingTop: "4px",
        }),
        // $(" .hoverContainer", {
        //     position: "absolute",
        //     bottom: "-58px",
        //     left: 0,
        //     right: 0,
        //     zIndex: 10,
        //     backgroundColor: theme.palette.darkGrey,
        //     color: "white",
        //     display: "flex",
        //     flexDirection: "column",
        //     justifyContent: "center",
        //     height: "58px",
        //     lineHeight: "14px",
        //     padding: "0 8px",
        //     transition: "all 0.2s ease-out",
        // }),
        // $(":hover .hoverContainer", {
        //     bottom: 0,
        // }),
        // $(" .hoverContainer dl", {
        //     margin: "0 0 4px",
        //     padding: 0,
        // }),
        // $(" .hoverContainer dl dt", {
        //     margin: "0 4px 0 0",
        //     padding: 0,
        //     display: "inline-block",
        //     color: theme.palette.lightGrey,
        //     fontSize: "10px",
        // }),
        // $(" .hoverContainer dl dd", {
        //     margin: 0,
        //     padding: 0,
        //     display: "inline-block",
        //     color: "white",
        //     fontSize: "11px",
        // }),
        // $(" .hoverContainer dl dd strong", {
        //     margin: 0,
        //     padding: 0,
        //     fontWeight: "bold",
        //     color: "white",
        //     fontSize: "12px",
        // }),
        $(" .selectedColorSwatch", {
            height: "22px",
            width: "22px",
            borderRadius: "11px",
            border: "solid 1px #c1c1c1",
            backgroundSize: "22px !important",
            marginRight: "4px",
            flexShrink: 0,
        }),
        $(" .colorContainer .color", {
            lineHeight: "20px",
            fontSize: "11px",
            overflow: "hidden",
            whiteSpace: "nowrap ",
            textOverflow: "ellipsis",
            paddingLeft: 0,
            width: "68px",
            height: "16px",
        }),
        $(" .colorName", {
            lineHeight: "22px",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
        }),
        $(" .cartTotals", {
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
        }),
        $(" .cartTotals.thereAreNotLines", {
            paddingTop: "0",
            minHeight: "22px",
        }),
        $(" .cartTotals p", {
            margin: "0.75rem 0 0 0",
        }),
        $(" .cartTotals dt", {
            display: "inline-block",
        }),
        $(" .cartTotals dd", {
            display: "inline-block",
        }),
        $(
            " .cartTotals.hasOnlyUnits, .cartTotals.hasOnlyOneUnit, .cartTotals.hasOnlyOneTotal, .cartTotals.hasOneTotalAndOneUnit",
            {
                height: "50px",
            }
        ),
        $(" .cartTotals.hasOnlyTotals", {
            height: "74px",
        }),
        $(" .cartTotals.hasTotalsAndOneUnit", {
            height: "66px",
        }),
        $(" .cartTotals.hasOnlyTotals.thereAreNotLines", {
            height: "66px",
        }),
        $(" .cartTotals.hasTotalsAndOneUnit.thereAreNotLines", {
            height: "50px",
        }),
        $(
            " .cartTotals.hasOnlyUnits.thereAreNotLines, .cartTotals.hasOnlyOneUnit.thereAreNotLines, .cartTotals.hasOnlyOneTotal.thereAreNotLines, .cartTotals.hasOneTotalAndOneUnit.thereAreNotLines",
            {
                height: "33px",
            }
        ),
        $(" .cartTotals p:first-child", {
            marginTop: "1rem",
        }),
        $(" .cartTotals dl", {
            margin: "0 0 4px",
            padding: 0,
            lineHeight: "14px",
        }),
        $(" .cartTotals dl:last-child", {
            margin: "0px",
        }),
        $(" .cartTotals dl dt", {
            margin: "0 4px 0 0",
            padding: 0,
            display: "inline-block",
            color: theme.palette.darkGrey,
            fontSize: "10px",
        }),
        $(" .cartTotals dl dd", {
            margin: 0,
            padding: 0,
            display: "inline-block",
            color: theme.palette.darkestGrey,
            fontSize: "12px",
            fontWeight: "bold",
        }),
        $(" .brokenLink", {
            backgroundColor: theme.palette.darkGrey,
            borderRadius: "50%",
            position: "absolute",
            transform: "translateY(-50%)",
            height: "16px !important",
            width: "16px !important",
            bottom: "0px",
            right: "10px",
        }),
        $(" .brandName", {
            fontSize: "10px !important",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            color: "#989898 !important",
            padding: "2px 0 0 !important",
            height: "16px",
        }),
        $(" .productName", {
            padding: "1px 0 !important",
            lineHeight: "16px !important",
            fontSize: "12px !important",
            fontWeight: "bold",
            color: "#2d2d2d !important",
            paddingTop: "4px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            height: "16px",
        }),
        $(" .styleNumber", {
            height: "16px",
            padding: "0 !important",
            fontSize: "10px !important",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
        }),
        $(" .colorSwatch", {
            height: "22px !important",
            width: "22px !important",
            marginRight: "4px",
            marginBottom: "0px !important",
        }),
        $(" .colorContainer", {
            paddingTop: "0px !important",
        }),
        $(" .colorContainer.thereAreNotLines", {
            paddingTop: "4px !important",
        }),
        $(" .moreActions", {
            position: "absolute !important",
            opacity: 0,
            top: "0px",
            right: "0px",
            transition: "all 0.2s ease-out",
            zIndex: 1100,
        }),
        $(" .isTouchDevice & .node .moreActions", {
            opacity: 1,
        }),
        $(" .node:hover .moreActions", {
            opacity: 1,
        })
    );
});

export { getStyles };
